var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionSigninline = function SvgQuestionSigninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.5 0 5.3 1.2 5.3 2.7v18.7C5.3 22.8 6.5 24 8 24h13.3c1.5 0 2.7-1.2 2.7-2.7V2.7C24 1.2 22.8 0 21.3 0H8zM0 1.3v21.3h2.7V1.3H0zm8 1.4h13.3v18.7H8V2.7zm6.7 2.6c-1.2 0-2.3.5-3 1.3-.7.8-1 1.7-1 2.7h2.7c0-.4.1-.7.3-.9.2-.2.5-.4 1-.4s.8.2 1 .4c.2.2.3.6.3 1 0 .8-.4 1.2-1 2-.6.7-1.7 1.8-1.7 3.4H16c0-.4.3-.8 1-1.6s1.7-2 1.7-3.7c0-1-.3-2-1-2.8-.8-.9-1.8-1.4-3-1.4zM13.3 16v2.7H16V16h-2.7z"
  })));
};
export default SvgQuestionSigninline;